import AdminLoadable from 'components/core/AdminLoadable';

export default AdminLoadable({
  loader: () => import('./CommunityManager'),
  name: 'CommunityManager',
});
